var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Bem vindo "),_c('b',[_vm._v(" "+_vm._s(_vm.full_name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }